/* ui/tournament/ResetButton.svelte generated by Svelte v3.23.2 */
import {
	SvelteComponent,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_custom_element_data
} from "svelte/internal";

import { game } from "../store";
import { resultsStore } from "./tournament_store";

function create_fragment(ctx) {
	let sl_button;
	let mounted;
	let dispose;

	return {
		c() {
			sl_button = element("sl-button");

			sl_button.innerHTML = `<sl-icon slot="prefix" name="arrow-counterclockwise"></sl-icon>
  Reset
`;

			set_custom_element_data(sl_button, "type", "info");
			set_custom_element_data(sl_button, "size", "small");
		},
		m(target, anchor) {
			insert(target, sl_button, anchor);

			if (!mounted) {
				dispose = listen(sl_button, "click", /*reset*/ ctx[0]);
				mounted = true;
			}
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(sl_button);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self) {
	function reset() {
		game.reset();
		resultsStore.update(() => [0, 0, 0]);
	}

	return [reset];
}

class ResetButton extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default ResetButton;